import check from 'check-types';
import { format, isValid } from 'date-fns';

export const dateFormater = (oldValue, newValue) => {
  if (oldValue !== null) {
    if (oldValue.length > newValue.length) {
      return newValue;
    }
  }

  return newValue.replace(/^(\d{4})(\d{2})(\d{2})/, '$1-$2-$3').substring(0, 10);
};

export const yearFormater = (oldValue, newValue) => {
  if (oldValue !== null) {
    if (oldValue.length > newValue.length) {
      return newValue;
    }
  }

  return newValue.substring(0, 4);
};

export const monthFormater = (oldValue, newValue) => {
  if (oldValue !== null) {
    if (oldValue.length > newValue?.length) {
      return newValue;
    }
  }

  return newValue?.substring(0, 2);
};

export const getDate = (date) => {
  const dateValue = new Date(date);
  return check.date(dateValue) ? dateValue : null;
};

export const getDateFormat = (dateFormat) => {
  let format = dateFormat || 'dd/MM/yyyy';
  format = format.replace('YYYY', 'yyyy').replace('DD', 'dd');
  return format;
};

export const reformatDate = (date) => {
  const dateValue = new Date(date);
  if (!isValid(dateValue)) return null;
  return format(dateValue, 'yyyy-MM-dd');
};
